<template>
  <!-- After the Save to list dialog closes: "Saved to Favourites and Hiker list" with
       Change, which opens the dialog again. Goes by itself after a few seconds. -->
  <div v-if="note" class="stl-page-note" role="status" data-test="save-to-list-page-note">
    <span class="msg">{{ note.text }}</span>
    <button type="button" data-test="save-to-list-change" @click="change">{{ $t('save_to_list.change') }}</button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { OnBoardingGoal } from '../../../utils/models/OnBoardingGoal';

// How long the note stays on the page.
export const PAGE_NOTE_MS = 6000;

export default defineComponent({
  computed: {
    note() {
      return this.$store.state.onBoarding.saveToListNote;
    },
  },
  watch: {
    note(value) {
      clearTimeout(this.timer);
      if (value) this.timer = setTimeout(() => this.$store.commit('onBoarding/setSaveToListNote', null), PAGE_NOTE_MS);
    },
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  methods: {
    change() {
      clearTimeout(this.timer);
      this.$store.commit('onBoarding/setSaveToListNote', null);
      window.onBoardingVue?.launchFor(OnBoardingGoal.AddTrailToList);
    },
  },
});
</script>

<style scoped>
.stl-page-note {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 1045;
  transform: translateX(-50%);
  width: min(440px, calc(100% - 32px));
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fddf00;
  color: #36220f;
  border-radius: 10px;
  padding: 12px 14px;
  font: 700 14px/1.35 Montserrat, sans-serif;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.stl-page-note .msg { flex: 1; min-width: 0; overflow-wrap: anywhere; }
.stl-page-note button {
  margin-left: auto;
  background: transparent;
  border: 0;
  color: inherit;
  font: 700 14px Montserrat, sans-serif;
  text-decoration: underline;
  cursor: pointer;
  padding: 2px 4px;
}
.stl-page-note button:focus-visible { outline: 2px solid #36220f; outline-offset: 2px; }
</style>
